<template>
  <div v-if="klassesLoaded" class="admin-klasses">
    <div class="top-form">
      <h3>{{ $store.state.user.langEng ? 'All classes' : 'Alla klasser' }}</h3>
      <router-link to="/admin/klasses/edit" class="btn-flat" id="newKlassButton">
        {{ $store.state.user.langEng ? 'Add new class' : 'Lägg till en ny klass' }}
      </router-link>
    </div>
    <div class="course-table">
      <admin-table
        :columns="columns"
        :buttons="showButtons"
        :data="klasses"
        @edit="editKlass"
        @deactivate="deactivateKlass"
        @row-click="rowClicked"
      />
    </div>
  </div>
  <div v-else class="preloader-wrapper big active">
    <div class="spinner-layer spinner-blue-only">
      <div class="circle-clipper left">
        <div class="circle"></div>
      </div><div class="gap-patch">
        <div class="circle"></div>
      </div><div class="circle-clipper right">
        <div class="circle"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import AdminTable from '@/components/Admin/AdminTable.vue';
import AdminSelect from '@/components/Admin/AdminSelect.vue';
import { Api, Rest } from '../utils';

@Component({
  components: { AdminTable, AdminSelect }
})
export default class AdminCourses extends Vue {
  columns = [
    {
      header: () => this.$store.state.user.langEng ? 'Class' : 'Klass',
      value: (klass) => `<span ${klass.inactive && 'style="color: gray"'}>${klass.slug}</span>`
    },
    {
      header: () => this.$store.state.user.langEng ? 'Education' : 'Utbildning',
      value: (klass) => `<span ${klass.inactive && 'style="color: gray"'}>${klass.name ? klass.name : 'N/A'}</span>`
    },
    {
      header: () => this.$store.state.user.langEng ? 'School' : 'Skola',
      value: (klass) => `<span ${klass.inactive && 'style="color: gray"'}>${klass.school[0] ? klass.school[0].name : 'N/A'}</span>`
    }
  ];
  
  klasses = [];
  klassesLoaded = false;

  get isEng() {
    return this.$store.state.user.langEng;
  }

  get currentKlass() {
    return this.klasses[this.selectedKlass];
  }

  get showButtons() {
   return !this.mobile;
  }

  get mobile() {
    return this.$store.state.isMobile;
  }

  editKlass(klass) {
    this.$router.push({
      name: 'adminEditKlass',
      params: { slug: klass.slug }
    });
  }

  async deactivateKlass(klass) {
    let klassToUpdate = {
      id: klass.id,
      inactive: !klass.inactive
    }

    let res = await Api.post('admin/set-active/Klass', klassToUpdate)
    if(res.id) {
      klass.inactive = res.inactive
    }
  }
  rowClicked(klass) {
    if (this.$store.state.isMobile) {
      this.$router.push({
        name: 'adminEditKlass',
        params: { slug: klass.slug }
      });
    }
  }

  async fetchKlasses() {
    const klasses = await Rest.get("Klass", {
      sort: { name: "ASC" },
      eager: { courses: true, school: true },
    });

    // map them to slug names
    let klassObj = {};
    for (const [, value] of Object.entries(klasses)) {
      klassObj[value.slug] = value;
    }

    return klassObj;
  }

  async created() {
    this.klasses = await this.fetchKlasses(); // too slow store load-in so we manually load it here

    setTimeout(() => {
      const elems = document.querySelectorAll('select');
      this.$M.FormSelect.init(elems);
    }, 0);

    this.klassesLoaded = true;
  }
}
</script>

<style scoped lang="scss">
.admin-klasses {
  $btn-color: #585858;

  .top-form {
    padding-top: 3em;
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: space-between;

    h3 {
      font-size: 1.5em;
      font-weight: bold;
      text-align: end;
      justify-self: left;
      margin-left: 1em;
    }

    .btn-flat {
      border: solid 1px $btn-color;
      color: $btn-color;
      font-weight: bold;
      text-transform: initial;

      &:hover {
        background-color: lightgray;
      }
    }

    #newKlassButton {
      justify-self: right;
      margin-right: 1.5em;
    }
  }

  .course-table {
    margin: 2em 0;
    padding: 0 1em;
  }
}

.mobile {
  .admin-klasses {
    padding: 0 15px;
  }

  .top-form {
    grid-template-columns: 1fr 1fr;
    // row-gap: 0.5em;
    justify-items: center;
    padding-top: 1em;
    
    h3 {
      font-size: 1.2em;
      justify-self: left;
      align-self: center;
      margin: 0;
    }

    #newKlassButton {
      justify-self: left;
      text-align: center;
      width: 100%;
    }
  }

  .course-table {
    padding: 0 0;
  }
}
</style>
